export default __webpack_public_path__ + "static/media/Synapse.4974674c.svg";